import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { listTasks } from '@/api/tasks';
import StatusBadge from '@/components/StatusBadge';
import { IN_FLIGHT_STATUSES } from '@/types/api';
import { formatDistance } from '@/lib/format';

export default function InFlightPanel() {
  const { t } = useTranslation('dashboard');
  const q = useQuery({
    queryKey: ['tasks', 'in-flight'],
    queryFn: () =>
      listTasks({ status: IN_FLIGHT_STATUSES, limit: 10, order: 'started_desc' }),
    refetchInterval: 10_000,
    refetchIntervalInBackground: false,
  });
  const items = q.data?.items ?? [];

  return (
    <div className="flex flex-col rounded-md border bg-card">
      <div className="border-b px-3 py-2 text-xs font-medium">
        {t('inFlight.title', { n: items.length })}
      </div>
      {items.length === 0 ? (
        <div className="p-3 text-xs text-muted-foreground">{t('inFlight.empty')}</div>
      ) : (
        <ul className="divide-y text-xs">
          {items.map((item) => (
            <li key={item.id}>
              <Link
                to={`/tasks/${item.id}`}
                className="flex items-center gap-2 px-3 py-2 hover:bg-accent"
              >
                <span className="truncate">{'📞'} {item.num_a ?? '—'}</span>
                <StatusBadge status={item.status} />
                <span className="ml-auto text-muted-foreground">
                  {formatDistance(item.call_started_at)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
